export default __webpack_public_path__ + "images/chevron_right.svg";